export const ADD_TO_CART = 'ADD TO CART';
export const UPDATE_ITEM = 'UPDATE ITEM';
export const COMPLETE_REQUIRED_INFO_ABOVE = 'COMPLETE REQUIRED INFO ABOVE';
export const ORDERING_NOT_AVAILABLE = 'Ordering Not Available';
